import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModelPortfoliosRoutingModule } from './model-portfolios-routing.module';
import { StaticPageFooterModule } from 'src/app/shared/static-page-footer/static-page-footer.module';
import { ModelPortfoliosComponent } from 'src/app/pages/model-portfolios/model-portfolios.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { HtmlFormatPipeModule } from 'src/app/pipes/html-format-pipe.module';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    ModelPortfoliosComponent,
  ],
  imports: [
    CommonModule,
    ModelPortfoliosRoutingModule,
    StaticPageFooterModule,
    HtmlFormatPipeModule,
    TranslateModule,
    RouterModule,
  ],
  exports: [
    ModelPortfoliosComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class ModelPortfoliosModule { }
